module.exports = __webpack_public_path__ + "static/media/unj.ded44c2c.png";